import { useContext } from "react";
import { Context } from "Context";
import Item from "./Item";
import SocialMediaIcon from "./SocialMediaIcon";
import Link from "components/shared/Link";

const socialInformationItemClass = "syndicated-footer__social-information-item";

const SocialLeadGenItem = ({ id, descriptions = [] }) => {
	const {
		profileData: {
			user = null,
			handleSubscription,
			showSubscriptionMessage,
			isOneIdSource,
		} = {},
	} = useContext(Context);
	const subscribeMessage = descriptions[0];
	const subscriptionConfirmationMessage = descriptions[1];
	const elementToRender = showSubscriptionMessage
		? subscriptionConfirmationMessage
		: subscribeMessage;
	const { url: imageUrl } = elementToRender?.image || {};

	if (!elementToRender) {
		return null;
	}

	return (!user || (user && !user.subscribed)) &&
		isOneIdSource ? (
		<Item title={elementToRender.title} id={id}>
			<div className={socialInformationItemClass}>
				<SocialMediaIcon
					src={imageUrl}
					className={id ? `syndicated-social-icon--${id}` : ""}
				/>
				<div className={`${socialInformationItemClass}__content`}>
					<span>{elementToRender.text}</span>
					{elementToRender.link && (
						<Link
							{...elementToRender.link}
							className="syndicated-footer__link"
							handleClick={(event) => handleSubscription(event)}
						/>
					)}
				</div>
			</div>
		</Item>
	) : null;
};

export default SocialLeadGenItem;
